
import Vue from 'vue';

import * as _ from 'lodash'

// gpu计算型--GPU高效计算型（P5V）、GPU通用计算型(P3)、GPU推理计算型(P3I)、GPU通用计算型(P4V)  、GPU推理计算型(P3IN) 、推理Ⅱ型(GN6I)、GPU通用计算型(P3L)、GPU推理I型(GN5I)、GPU通用计算型GN7I
const gpu1 = [661, 353, 101, 326, 77, 125, 126, 142, 597, 690]
// GPU虚拟化型--GPU虚拟型(vGN5)/GPU虚拟型（vGN6）
const gpu2 = [321, 377]

//1/2代机型: 通用型N1、IO优化型I1、计算优化型C1、IO优化型I1(联网增强)、计算优化型C1(联网增强)、IO优化型I2、IO优化型I2(联网增强)、通用型N2、性能保障型X2、标准型S1、基础型E1、容器实例型、标准型SA1
const the1_2nd = [40, 41, 42, 45, 46, 78, 79, 137, 138, 298, 303, 192, 198]


import * as productService from '../../services/kec/product'

const productSortMap:{[k:string]:[string, string, number]} = {
    '通用型': ["COMVM", Vue.$trans(`通用型`), 1],
    '标准型': ["SNVM", Vue.$trans(`标准型`), 2],
    '高效型': ["SE", Vue.$trans(`高效型`), 3],
    'IO优化型': ["IOVM", Vue.$trans(`IO优化型`), 4],
    '计算优化型': ["CALVM", Vue.$trans(`计算优化型`), 5],
    '容器实例型': ["CONTAINER", Vue.$trans(`容器实例型`), 6],
    '性能保障型': ["XVM", Vue.$trans(`性能保障型`), 7],
    '专属型NI6': ["XVM", Vue.$trans(`性能保障型`), 7],
    '标准网络型': ["SN3", Vue.$trans(`标准网络型`), 8],
    '基础型': ["EVM", Vue.$trans(`基础型`), 9],
    '大数据型': ["BDM", Vue.$trans(`大数据型`), 10],
    '内存型': ["RVM", Vue.$trans(`内存型`), 11],
    '性能保障型X6H': ["NPEVM", Vue.$trans(`增强型`), 12],
    '极速云盘型': ["NPEVM", Vue.$trans(`增强型`), 12],
    '增强型': ["NPEVM", Vue.$trans(`增强型`), 12],
    '星河': ["HKEC", Vue.$trans(`星河`), 13],
    '弹性裸金属': ["EPCX7", Vue.$trans(`弹性裸金属`), 14],
};

//国内(CN)、亚太(AP)、欧洲(EU)
const areaCodeMap = ['cn', 'ap', 'eu'];

const productTypeNameMatchReg = new RegExp(_.keys(productSortMap).join('|'))

const initArchMap = (allData:any):{[k:string]:any} => {
    return {
        all: {
            archCode: 'all',
            archName: Vue.$trans(`全部架构`),
            data: allData, //ipItem.data,
            sortKey: 0,
            sortMap: {}
        },
        amd: {
            archCode: 'amd',
            archName: 'AMD',
            data: [],
            sortKey: 3,
            sortMap: {}
        },
        arm: {
            archCode: 'arm',
            archName: 'ARM',
            data: [],
            sortKey: 2,
            sortMap: {}
        },
        gpu: {
            archCode: 'gpu',
            archName: 'GPU',
            data: [],
            sortKey: 4,
            sortMap: {}
        },
        x86: {
            archCode: 'x86',
            archName: Vue.$trans(`x86计算`),
            data: [],
            sortKey: 1,
            sortMap: {}
        }
    }
}

const formatIpItem = (ipItem:any) => {
    // console.time('forEach ipv6list')
    let archMap = initArchMap(ipItem.data);
    // console.log(ipItem.data, 3)
    _.forEach(ipItem.data, (kecItem:any) => {
        //---- 1
        let archCode = productService.getArchById(kecItem.productTypeId)

        // 没配置具体信息的机型（新机型），忽略不计
        if (!archCode || !archMap[archCode]) {
            return;
        }
        //     (() => {
        //     if (kecItem.productTypeId == 198) {
        //         return 'amd';
        //     }
        //     if (kecItem.generation.toLowerCase() == "arm") {
        //         return 'arm';
        //     }
        //     if (kecItem.generation.toLowerCase() == "gpu") {
        //         return 'gpu';
        //     }
        //     return 'x86';
        // })();


        archMap[archCode].data.push(kecItem);
        //---- 2 sort分类
        let productTypeName = kecItem.productTypeName || '' //_.get(kecItem, 'productTypeName', '');
        let productTypeId = kecItem.productTypeId || '' //_.get(kecItem, 'productTypeId', '')

        let [sortCode, sortName, sortKey] = (() => {
            // console.time('regex match')
            let name = productTypeName.match(productTypeNameMatchReg)
            // console.timeEnd('regex match')

            if (the1_2nd.indexOf(productTypeId) !== -1) {
                return ["X8612VM", Vue.$trans(`1/2代机型`), 15];
            }

            if (name && name[0] && productSortMap[name[0]]) {
                return productSortMap[name[0]]
            }
            if (gpu1.indexOf(productTypeId) !== -1) {
                return ["GPU1", Vue.$trans(`GPU计算型`), 13]
            }
            if (gpu2.indexOf(productTypeId) !== -1) {
                return ["GPU2", Vue.$trans(`GPU虚拟化型`), 14]
            }
            return [undefined, undefined, undefined]
        })()
        // 处理all的sortMap 以及 所属arch的sortMap
        _.forEach(['all', archCode], (curArchCode:string) => {
            let curArch = archMap[curArchCode]
            if (!curArch.sortMap.all) {
                curArch.sortMap.all = {
                    sortCode: 'all',
                    sortName: Vue.$trans(`全部分类`),
                    sortKey: 0,
                    data: []
                }
            }
            curArch.sortMap.all.data.push(kecItem)

            // 如果sortCode不存在 说明这个机型不用细分类型
            // 只需要放进all就ok 这里就可以跳过了
            if (!sortCode) {
                return;
            }
            if (!curArch.sortMap[sortCode]) {
                curArch.sortMap[sortCode] = {
                    sortCode, sortName, sortKey,
                    data: []
                }
            }
            curArch.sortMap[sortCode].data.push(kecItem);
        })
    })
    let archList:any[] = [];
    _.forEach(archMap, (archObj, archCode) => {

        if (archObj.data.length) {
            let sortList:any[] = [];
            _.forEach(archObj.sortMap, (sortObj, sortCode) => {
                if (sortObj.data.length) {
                    sortList.push(sortObj);
                }
            });
            archObj.sortMap = null;
            archObj.sortlist = sortList;
            archList.push(archObj);
        }
    })
    ipItem.archList = archList;
}

export default {
    _handleData(allProduct:any, isCluster:boolean, self:any, ipv6List:any, isReservedInstance:boolean, isRandomAzCode:boolean) {
        console.time('_handleData')
        // console.log(ipv6List, 123)
        let me = self;
        // 价格体系返回的数据处理
        let result:any[] = [];
        let products = [];
        if (isCluster) {
            _.forEach(allProduct, (list, index) => {
                let gpuType = _.find(list.propertyList, ['propCode', 'gpu']);
                if (!gpuType) {
                    products.push(list)
                }
            })
        } else {
            products = allProduct;
        }
        _.each(products, list => {
            let billTypes = list.billTypeList;
            let propertys = list.propertyList;
            let set = _.find(propertys, ['propCode', 'generation']) || {};


            // 主机控制台是否要屏蔽该机型, true: 隐藏，不配置则正常展示。
            let vmConsoleShielded = '';
            let vmConsoleShieldedObj = _.find(propertys, ['propCode', 'VMCONSOLESHIELDED']) || {};
            if (!_.isEmpty(vmConsoleShieldedObj)) {
                vmConsoleShielded = _.get(vmConsoleShieldedObj, 'propValue[0].value', '');
            }
            if (vmConsoleShielded === 'true') {
                return;
            }

            let isReservedInstancesOffering = false;

            // 只有预留实例包引用组件，才判断prop里的预留实例标记
            if (isReservedInstance) {
                let propReservedInstancesOffering = _.find(propertys, ['propCode', 'ReservedInstancesOffering']);
                if (propReservedInstancesOffering) {
                    isReservedInstancesOffering = _.get(propReservedInstancesOffering, 'propValue[0].value', '')
                }
            }
            // let isReservedInstancesOffering = _.get( || {}, 'propValue[0].value', '');
            let packageList = list.packageList;
            _.each(billTypes, bill => {
                let billtype = bill;
                if (packageList.length === 0) return;
                _.each(packageList, pack => {
                    let regions = pack.refRegionList;

                    // pack属性的生成放在regions循环的外面
                    let packProps:{[k:string]:any} = {
                        cpu: '',
                        mem: '',
                        ssd: '',
                        hhd: '',
                        gpu: '',
                        // ReservedInstancesOffering: ''
                    };
                    // 由于对packageInfo的多个字段都需要提取，所以每个都用find效率低，应该一个循环取全部
                    _.forEach(pack.packageInfo, packageItem => {
                        switch(packageItem.propCode) {
                            case 'cpu':
                            case 'mem':
                            case 'ssd':
                            case 'hdd':
                            case 'gpu':
                                packProps[packageItem.propCode] = _.get(packageItem, 'propValue[0].min');
                                break
                        }
                    });

                    _.each(regions, reg => {
                        let azs = reg.azList;
                        _.each(azs, az => {
                            let basicData:any = _.assign({}, packProps);
                            basicData.region = reg;
                            basicData.regionCode = reg.regionCode;
                            basicData.regionName = reg.regionName;
                            basicData.az = az;
                            basicData.azCode = az.azCode;
                            basicData.azName = az.azName;
                            basicData.generation = set.propValue[0].value;
                            basicData.generationName = set.propValue[0].name;
                            basicData.set = set;
                            basicData.product = list;
                            basicData.productTypeId = list.productTypeId;
                            basicData.productTypeName = list.productTypeName;
                            basicData.propertyList = list.propertyList;
                            basicData.billtype = billtype;
                            basicData.billTypeId = billtype.billTypeId;
                            basicData.billTypeName = billtype.billTypeName;
                            basicData.packageInfo = pack.packageInfo;
                            basicData.packageCode = pack.packageCode;

                            basicData.kecKey = `${list.productTypeId}_${basicData.cpu}_${basicData.mem}_${basicData.ssd}_${basicData.packageCode}`
                            if (basicData.gpu) {
                                basicData.kecKey = `${basicData.kecKey}_${basicData.gpu}`
                            }

                            if (isReservedInstance) {
                                //预留实例包 只显示有”ReservedInstancesOffering“标识的机型套餐
                                if (isReservedInstancesOffering) {
                                    result.push(basicData);
                                }
                            } else {
                                result.push(basicData);
                            }

                        })
                    })
                })
            })
        });
        let arr:any[] = [];
        //按billtype分组
        _.each(result, each => {
            let billObj:any = {};
            _.each(arr, item => {
                if (each.billTypeId == item.billTypeId) {
                    billObj = item;
                }
            })
            if (isCluster && each.billTypeId != 5) return;
            //容器只支持按日 月结
            if (billObj.billTypeId) {
                billObj.data.push(each);
            } else {
                billObj.billTypeId = each.billTypeId;
                billObj.billTypeName = each.billTypeName;
                // var datas = [];
                // datas.push(each);
                billObj.data = [each];
                arr.push(billObj)
            }
        })
        console.timeLog('_handleData', 3)

        //不区分计费方式 （此处只TMD为了满足购买预留实例包需求）
        if (isReservedInstance) {
            let arr2:any[] = [];
            let tempData:any[] = [];
            _.each(result, each => {
                let billObj2:any = {};
                _.each(arr2, item => {
                    if (each.cpu == item.cpu && each.mem == item.mem && each.productTypeId == item.productTypeId && each.azCode == item.azCode && each.regionCode == item.regionCode) {
                        billObj2 = item;
                    }
                })
                if (!billObj2.billTypeId) {
                    billObj2.regionCode = each.regionCode;
                    billObj2.billTypeId = each.billTypeId;
                    billObj2.billTypeName = each.billTypeName;
                    billObj2.cpu = each.cpu;
                    billObj2.mem = each.mem;
                    billObj2.productTypeId = each.productTypeId;
                    billObj2.azCode = each.azCode;
                    arr2.push(billObj2);
                    tempData.push(each);
                }
            })
            arr = [{
                billTypeId: 2020, //无预留: 2020
                billTypeName: me.$trans(`无预留`), //'无预留',
                data: tempData
            }];
        }

        //按region分组
        _.each(arr, list => {
            let regions:any[] = [];
            _.each(list.data, each => {
                let regionObj:any = {};
                _.each(regions, item => {
                    if (each.regionCode == item.regionCode) {
                        regionObj = item;
                    }
                })
                if (isCluster && (each.regionCode != me.regionKey)) return;
                //容器只支持北京6区
                if (regionObj.regionCode) {
                    regionObj.data.push(each);
                } else {
                    regionObj.regionCode = each.regionCode;
                    regionObj.regionName = each.regionName;
                    regionObj.areaCode = each.regionCode.split('-')[0];
                    // var datas = [];
                    // datas.push(each);
                    regionObj.data = [each];
                    regions.push(regionObj);
                }
            })
            regions = _.sortBy(regions, function (item) {
                return _.indexOf(areaCodeMap, item.areaCode);
            });
            list.regions = regions;
        })

        //按az分组
        _.each(arr, list => {
            _.each(list.regions, each => {
                let azs:any = []
                let regionData = each.data;
                _.each(regionData, item => {
                    let azObj:any = {};
                    _.each(azs, az => {
                        if (item.azCode === az.azCode) {
                            azObj = az;
                        }
                    })
                    if (azObj.azCode) {
                        azObj.data.push(item)
                    } else {
                        azObj.azCode = item.azCode;
                        azObj.azName = item.azName;
                        // let datas = [];
                        // datas.push(item);
                        azObj.data = [item];
                        azs.push(azObj);
                    }
                })
                azs.sort((a:any, b:any) => {
                    let azCode_a = _.get(a, 'azCode', '');
                    let azCode_b = _.get(b, 'azCode', '');
                    // return a.azCode.localeCompare(b.azCode);
                    return azCode_a.charCodeAt(azCode_a.length - 1) - azCode_b.charCodeAt(azCode_b.length - 1);
                });
                if(isRandomAzCode){
                    azs.unshift({
                        azCode:'all',
                        azName:me.$trans(`随机可用区`),
                        data:regionData
                    })
                }
                each.azs = azs;
            })
        })

        //不区分可用区 （此处只TMD为了满足购买预留实例包需求）
        if (isReservedInstance) {
            let azCodeList:any[] = []
            _.each(arr, list => {
                _.each(list.regions, each => {
                    _.each(each.azs, item => {
                        azCodeList.push(item.azCode);
                    });
                });
            });
            me.bossAzCodeList = azCodeList;
            _.each(arr, list => {
                _.each(list.regions, each => {
                    let azs:any[] = [];
                    let tempData:any[] = [];
                    let regionData = each.data;

                    _.each(regionData, item => {
                        let azObj:any = {};
                        _.each(azs, az => {
                            if (item.cpu == az.cpu && item.mem == az.mem && item.productTypeId == az.productTypeId && item.regionCode == az.regionCode) {
                                azObj = az;
                            }
                        })
                        if (!azObj.azCode) {
                            azObj.azCode = item.azCode;
                            azObj.regionCode = item.regionCode;
                            azObj.azName = item.azName;
                            azObj.cpu = item.cpu;
                            azObj.mem = item.mem;
                            azObj.productTypeId = item.productTypeId;
                            azs.push(azObj);
                            tempData.push(item);
                        }
                    })
                    each.azs = [{
                        azCode: '20200604',
                        azName: me.$trans(`跨可用区`), //'跨可用区',
                        data: tempData
                    }];
                });
            });
        }

        // 取cpu分组
        _.each(arr, list => {
            _.each(list.regions, regionItem => {

                // 支持ipv6的机型列表与region相关，可以提到这个位置
                let ipv6AvailableProductListOfRegion = ipv6List[regionItem.regionCode];
                if (!ipv6AvailableProductListOfRegion) {
                    ipv6AvailableProductListOfRegion = ipv6List.all;
                }

                _.each(regionItem.azs, az => {
                    let cpuMap:{[k:string]:any} = {
                        0: {
                            cpu_num: me.$trans(`全部`),
                            data: az.data
                        }
                    };
                    _.forEach(az.data, kecItem => {
                        if (!cpuMap[kecItem.cpu]) {
                            cpuMap[kecItem.cpu] = {
                                cpu_num: kecItem.cpu,
                                data: []
                            }
                        }
                        cpuMap[kecItem.cpu].data.push(kecItem);
                    });
                    let cpuList:any[] = [];
                    let listOfCpuNum = _.keys(cpuMap).sort((a, b) => Number(a) - Number(b))
                    _.forEach(listOfCpuNum, cpu => {
                        let cpuItem = cpuMap[cpu];
                        // 取mem分组
                        let memMap:{[k:string]:any} = {
                            0: {
                                mem: me.$trans(`全部`),
                                data: cpuItem.data
                            }
                        };
                        _.forEach(cpuItem.data, kecItem => {
                            let curMemInMap = memMap[kecItem.mem]
                            if (!curMemInMap) {
                                curMemInMap = memMap[kecItem.mem] = {
                                    mem: kecItem.mem,
                                    data: []
                                }
                            }
                            curMemInMap.data.push(kecItem);
                        });
                        let memList:any[] = [];
                        let listOfMemNum = _.keys(memMap).sort((a, b) => Number(a) - Number(b))
                        _.forEach(listOfMemNum, mem => {
                            let memItem = memMap[mem]
                            // 取ipv6分组
                            let allIpItem = {
                                'ipv6Name': me.$trans(`全部`),
                                'ipv6Code': 'all',
                                'data': memItem.data
                            };
                            formatIpItem(allIpItem)
                            memItem.ipv6List = [allIpItem];
                            let objSupportIpv6:any = {
                                'ipv6Name': me.$trans(`支持`),
                                'ipv6Code': 'yes',
                                'data': []
                            }
                            _.each(memItem.data, (kecItem:any) => {

                                // 机型是否支持ipv6
                                if (ipv6AvailableProductListOfRegion && ipv6AvailableProductListOfRegion.indexOf(kecItem.productTypeId) !== -1) {
                                    objSupportIpv6.data.push(kecItem)
                                    // obj.addKecToData(kecItem);
                                }
                            })
                            if (objSupportIpv6.data.length > 0) {
                                formatIpItem(objSupportIpv6);
                                // obj = obj.output();
                                memItem.ipv6List.push(objSupportIpv6)
                            }
                            memList.push(memItem)
                        });
                        cpuItem.memList = memList;

                        cpuList.push(cpuItem)
                    });
                    az.cpuList = cpuList;

                })
            })
        })
        // console.log(arr, 111)
        return arr;
    },
    _handleSoldoutData(data:any) {
        let soldoutData:any[] = [];
        _.forEach(data, item => {
            let obj:any = {};
            let packageCode:any[] = [];
            _.forEach(soldoutData, sitem => {
                if (sitem.az == item.AvailabilityZone) {
                    obj = sitem
                }
            })
            if (item.PackageSellOuts && item.PackageSellOuts.length) {
                _.forEach(item.PackageSellOuts, (pItem) => {
                    if (pItem.SellOutStatus) {
                        packageCode.push(pItem.PackageCode)
                    }
                })
            }

            if (obj.az) {
                if (item.AllSellOutStatus) {
                    if (!obj.kec) {
                        obj.kec = new Set();
                    }
                    obj.kec.add(item.ProductType);
                }
                obj.kecPackage.set(item.ProductType, packageCode);
            } else {
                obj.az = item.AvailabilityZone;
                if (item.AllSellOutStatus) {
                    if (!obj.kec) {
                        obj.kec = new Set();
                    }
                    obj.kec.add(item.ProductType);
                }
                //问题：
                //普通机型和联网增强型的套餐配置是一样的，
                //如果普通机型未售罄，但是联网增强型售罄，那么普通机型和联网增强型套餐code相同，普通机型也会售罄
                // 解决：
                //用机型的ID区分机型，只有机型ID和套餐code同时相同才售罄
                obj.kecPackage = new Map();
                obj.kecPackage.set(item.ProductType, packageCode);
                soldoutData.push(obj);
            }
        })
        return soldoutData;
    }
}
